import React from "react";

export default function Nav() {
    return (
        <div className="">
            <img src="images/7DSCCCalculator/bannerBackgroundImage.png" className="img-fluid" alt="Responsive" />
        </div>
    );
}
